import { SubscriptionFormValues } from "./types-dto"

export const subscribeFormValuesInitialValue = (): SubscriptionFormValues => {
    return {
        currency: ''
    }
}